import { ConfirmDelete } from "components/ConfirmDialog/ConfirmDelete";
import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { useApi } from "providers";
import { useParticipant } from "providers";
import { useToasts } from "providers";
import { useTranslations } from "providers";
import { useMeeting } from "providers";
import { useCallback } from "react";

export const ConfirmDeleteParticipant: React.FC = () => {
  const i18n = useTranslations();
  const toasts = useToasts();
  const { reloadMeeting } = useMeeting();
  const { participantsApi } = useApi();
  const { confirmDeleteParticipant, setConfirmDeleteParticipant, setParticipantDeleting } = useParticipant();

  const isOpen = confirmDeleteParticipant !== undefined;

  const handleDelete = useCallback(
    async (target?: ConfirmDeleteTarget) => {
      if (!target) return;

      setConfirmDeleteParticipant(undefined);
      setParticipantDeleting(target.id, true);

      try {
        await participantsApi.delete(target.id);
      } catch (error) {
        toasts.deleteFailure(i18n.Participant, target.title, error);
      } finally {
        reloadMeeting().finally(() => {
          setParticipantDeleting(target.id, false);
        });
      }
    },
    [participantsApi, reloadMeeting, setParticipantDeleting, setConfirmDeleteParticipant, i18n, toasts]
  );

  const setIsOpen = useCallback(
    (open: boolean) => {
      if (!open) {
        setConfirmDeleteParticipant(undefined);
      }
    },
    [setConfirmDeleteParticipant]
  );

  return (
    <ConfirmDelete
      entityName={i18n.Participant}
      entityTitle={confirmDeleteParticipant?.title}
      content={i18n.Actions_Delete_Participant_Confirm}
      onAccept={() => handleDelete(confirmDeleteParticipant)}
      onCancel={() => setConfirmDeleteParticipant(undefined)}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};
